import { UniversalWasteCategory } from "generated-graphql/graphql";

/** Reader-facing names for the universal waste categories. */
export function prettyPrintUniversalWasteCategory(category: UniversalWasteCategory): string {
  switch (category) {
    case UniversalWasteCategory.Batteries:
      return "Batteries";
    case UniversalWasteCategory.Pesticides:
      return "Pesticides";
    case UniversalWasteCategory.MercuryEquipment:
      return "Mercury-containing equipment";
    case UniversalWasteCategory.Lamps:
      return "Lamps";
    case UniversalWasteCategory.AerosolCans:
      return "Aerosol cans";
    case UniversalWasteCategory.ElectronicWaste:
      return "Electronic waste";
    case UniversalWasteCategory.CathodeRayTubes:
      return "Cathode ray tubes";
    case UniversalWasteCategory.Antifreeze:
      return "Antifreeze";
    case UniversalWasteCategory.Paint:
      return "Paint";
    case UniversalWasteCategory.Photovoltaic:
      return "Photovoltaic modules";
    case UniversalWasteCategory.DentalAmalgam:
      return "Dental amalgam";
    case UniversalWasteCategory.CompressedGas:
      return "Compressed gas";
    case UniversalWasteCategory.PcbBallasts:
      return "PCB ballasts";
    case UniversalWasteCategory.PhotoSolutions:
      return "Photo solutions";
  }
}
